"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Calendar: () => Calendar
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneCalendar");
  return hybrid;
}
function getPermissionStatus() {
  try {
    return native().getPermissionStatus();
  } catch (error) {
    return (0, import_nativeError.rethrowNativeError)(error);
  }
}
function requestPermission() {
  return native().requestPermission().catch(import_nativeError.rethrowNativeError);
}
function list(startMs, endMs) {
  var limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
  return native().list(startMs, endMs, limit).catch(import_nativeError.rethrowNativeError);
}
function create(input) {
  var _input_allDay;
  return native().create({
    ...input,
    allDay: (_input_allDay = input.allDay) !== null && _input_allDay !== void 0 ? _input_allDay : false
  }).catch(import_nativeError.rethrowNativeError);
}
function update(identifier, originalStartMs, changes) {
  return native().update(identifier, originalStartMs, changes).catch(import_nativeError.rethrowNativeError);
}
function deleteEvent(identifier, startMs) {
  return native().remove(identifier, startMs).catch(import_nativeError.rethrowNativeError);
}
function getRemindersPermissionStatus() {
  try {
    return native().getRemindersPermissionStatus();
  } catch (error) {
    return (0, import_nativeError.rethrowNativeError)(error);
  }
}
function requestRemindersPermission() {
  return native().requestRemindersPermission().catch(import_nativeError.rethrowNativeError);
}
function listReminders() {
  var limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100, includeCompleted = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  return native().listReminders(limit, includeCompleted).catch(import_nativeError.rethrowNativeError);
}
function createReminder(input) {
  return native().createReminder(input).catch(import_nativeError.rethrowNativeError);
}
function setReminderCompleted(identifier, completed) {
  return native().setReminderCompleted(identifier, completed).catch(import_nativeError.rethrowNativeError);
}
function deleteReminder(identifier) {
  return native().removeReminder(identifier).catch(import_nativeError.rethrowNativeError);
}
var nativeCalendar = Object.freeze({
  getPermissionStatus,
  requestPermission,
  list,
  create,
  update,
  delete: deleteEvent,
  getRemindersPermissionStatus,
  requestRemindersPermission,
  listReminders,
  createReminder,
  setReminderCompleted,
  deleteReminder
});
var Calendar = nativeCalendar;
//# sourceMappingURL=index.native.js.map
